<template>
  <b-tab title="Bônus" @click="onBonusTabClick()">
    <b-col lg="6" class="my-1">
      <b-row>
        <b-form-radio-group
                v-model="userRadioBonusSelected"
                buttons
        >
          <b-form-radio value="user" v-b-tooltip.hover title="Usuário Responsável">Usuário</b-form-radio>
          <b-form-radio value="cod" v-b-tooltip.hover title="Código">Código</b-form-radio>
          <b-form-radio value="name" v-b-tooltip.hover title="Nome">Nome</b-form-radio>
        </b-form-radio-group>
        <b-input-group size="sm" style="{padding-top: 10px; margin-top: 10px;}">
          <b-input-group-prepend is-text>
            <b-icon icon="search"></b-icon>
          </b-input-group-prepend>
          <b-form-input v-model="filterUserBonusText" v-on:keyup.enter="onUserBonusSearchClick()" type="search" placeholder="Buscar..."></b-form-input>
        </b-input-group>
      </b-row>
    </b-col>
    <b-table striped :fields="fields" :current-page="currentPage" :items="users" :per-page="0" stacked="md">
      <template v-slot:cell(bonus)="row">
        <b-row>
          <b-button class="item-table ml-3" @click="onBonusClick(row.item, row.index, $event.target)">+</b-button>
        </b-row>
      </template>
      <template v-slot:cell(priority)="row">
        <b-row class="text-center">
          <b-button class="item-table ml-3" @click="onPriorityClick(row.item, row.index, $event.target)">{{
            formatPriority(row.item.queuePriority)
          }}</b-button>
        </b-row>
      </template>
      <template v-slot:cell(purge)="row">
        <b-row>
          <b-button class="item-table ml-3" @click="onPurgeClick(row.item, row.index, $event.target)">{{ row.item.purge ? (row.item.purge / 24 / 60 / 60 / 1000) + ' dias' : '180 dias' }}</b-button>
        </b-row>
      </template>
    </b-table>
    <b-col sm="7" md="6" class="my-1">
      <b-pagination
              @input ="updateBonusPage()"
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              align="fill"
              size="sm"
              class="my-0"
      ></b-pagination>
    </b-col>
    <b-modal
      id="modal-prevent-closing"
      ref="modal"
      ok-title="Enviar"
      cancel-title="Cancelar"
      cancel-variant="transparent"
      :title="modalTitle"
      @hidden="resetModal"
      @ok="handleModalOk"
      size="md"
    >
      <b-form @submit.stop.prevent="handleSubmit">
        <b-row cols="3" cols-sm="3" cols-md="4" cols-lg="3">
          <b-col class="creditsBalance" style="margin-left=20px"></b-col>
          <b-col class="mb-2 creditsBalance">Aplicativo </b-col>
          <b-col class="creditsBalance">API</b-col>
          <b-col class="creditsBalance">Crédito Atual</b-col>
          <b-col class="creditsBalanceRight">{{ secondsToHour(currentCreditAvailable) }}</b-col>
          <b-col class="creditsBalanceRight">{{ secondsToHour(currentCreditApi) }}</b-col>
          <b-col class="creditsBalance">Reservado </b-col>
          <b-col class="creditsBalanceRight">{{ secondsToHour(currentCreditReserved) }}</b-col>
          <b-col class="creditsBalanceRight">{{ secondsToHour(currentCreditReservedApi) }}</b-col>
        </b-row>
        <br>
        <b-row>
          <b-col>
            <b-form-group label="Bônus" label-for="bonus-input" :state="bonusState" invalid-feedback="Não pode ser em branco">
              <b-form-input id="bonus-input" v-model="bonus" placeholder="Minutos" class="border border-dark" autofocus></b-form-input>
                <b-form-checkbox style="margin-top: 10px;" switch v-model="api">API</b-form-checkbox>
                <b-form-checkbox style="margin-top: 10px;" switch v-model="recurrence">Recorrência</b-form-checkbox>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>
    <b-modal id="modal-prevent-closing" ref="priorityModal" button-size="sm" ok-title="Enviar" cancel-title="Cancelar"
      cancel-variant="transparent" title="Prioridade da fila" @hidden="resetModal" @ok="handlePriorityModalOk" size="sm">
      <b-form @submit.stop.prevent="handlePrioritySubmit">
        <b-form-radio-group v-model="priority" class="w-50" stacked>
          <b-form-radio v-for="(item, index) in priorities" :value="item.value" :key="index"
          v-b-tooltip.hover>{{ item.label }}</b-form-radio>
        </b-form-radio-group>
      </b-form>
    </b-modal>

    <b-modal id="modal-prevent-closing" ref="purgeModal" button-size="sm" ok-title="Enviar" cancel-title="Cancelar"
      cancel-variant="transparent" title="Expurgo das transcrições" @hidden="resetPurgeModal" @ok="handlePurgeModalOk" size="sm">
      <b-form @submit.stop.prevent="handlePurgeSubmit">
        <b-form-radio-group v-model="priority" class="mr-3" stacked>
          <b-form-input type="number" id="input-small type-number" v-model="purgeUpdateValue" placeholder="Dias para fazer o expurgo"></b-form-input>
        </b-form-radio-group>
      </b-form>
    </b-modal>
  </b-tab>
</template>

<script>
  import { userService } from '../../services/user_service';

  export default {
    data () {
      return {
        tabType: '',
        perPage: 15,
        isLoading: false,
        userInfo: {},
        isAdmin: false,
        activeUsers: 0,
        inactiveUsers: 0,
        bonusState: null,
        users: [],
        priorities: [],
        totalRows: 1,
        userRadioBonusSelected: 'user',
        filterUserBonusText: '',
        currentPage: 1,
        purgeUpdateValue: 0,
        priorityState: null,
        bonus: '',
        currentUser: {},
        currentCreditAvailable: 0,
        currentCreditReserved: 0,
        currentCreditReservedApi: 0,
        priority: '',
        api: false,
        adminInfoLoaded: true,
        currentCreditApi: 0,
        fields: [
          { key: 'accountId', label: 'Cód', sortable: true },
          { key: 'name', label: 'Nome', sortable: true },
          { key: 'login', label: 'Login', sortable: true, thStyle: { width: '150px' } },
          { key: 'bonus', label: 'Bonus', sortable: false, thStyle: { width: '100px' } },
          { key: 'priority', label: 'Prioridade', sortable: true, thStyle: { width: '130px' } },
          { key: 'purge', label: 'Expurgo', sortable: false, thStyle: { width: '130px' } }
        ]
      };
    },
    async mounted () {
    },
    methods: {
      async onBonusTabClick () {
        this.tabType = 'user';
        this.priorities = await userService.getQueuePriority();
        await this.loadUserAdminInfo({ perPage: parseInt(this.perPage), currentPage: 1, adminTab: 'bonus' });
      },
      async loadUserAdminInfo (params) {
        this.isLoading = true;
        const result = await userService.userAdminInfo(params);
        if (result && result.length > 0) {
          this.isAdmin = true;
          this.activeUsers = result[1] ? result[1].active : this.activeUsers;
          this.inactiveUsers = result[2] ? result[2].nonActive : this.inactiveUsers;
          this.users = result[0].elements;
          this.pageInfo = result[0].pageInfo;
          this.totalRows = this.pageInfo && this.pageInfo.length > 0 && this.pageInfo[0].count;
        }
        this.isLoading = false;
      },
      secondsToHour (seconds) {
        seconds = parseInt(seconds, 10);

        if (isNaN(seconds)) {
          throw new TypeError('Invalid value sent to convert-seconds');
        }
        var results = {};
        results.hours = Math.floor(seconds / 60 / 60);
        results.minutes = Math.floor((seconds / 60) % 60);
        results.seconds = Math.floor(seconds % 60);

        return `${String(results.hours).padStart(2, '0')}:${String(results.minutes).padStart(2, '0')}:${String(results.seconds).padStart(2, '0')}`;
      },
      async onUserBonusSearchClick () {
        if (this.adminInfoLoaded) {
          if (this.userRadioBonusSelected === 'user' && this.filterUserBonusText.length > 2) {
            await this.loadUserAdminInfo({ perPage: parseInt(this.perPage), currentPage: parseInt(this.currentPage), user: this.filterUserBonusText.trim().toLowerCase() });
          } else if (this.userRadioBonusSelected === 'cod') {
            await this.loadUserAdminInfo({ perPage: parseInt(this.perPage), currentPage: parseInt(this.currentPage), accountId: this.filterUserBonusText.trim() });
          } else if (this.userRadioBonusSelected === 'name' && this.filterUserBonusText.length > 1) {
            await this.loadUserAdminInfo({ perPage: parseInt(this.perPage), currentPage: parseInt(this.currentPage), name: this.filterUserBonusText.trim() });
          } else {
            await this.loadUserAdminInfo({ perPage: parseInt(this.perPage), currentPage: parseInt(this.currentPage) });
          }
        }
      },
      async onBonusClick (item, index, target) {
        this.currentUser = item;
        const credit = await userService.userCredit(item.login);
        if (this.credit === 'Timeout') {
          this.isLoading = false;
          this.$toast.open({ message: 'Timeout de conexão!', type: 'error' });
          return;
        }
        this.currentCreditAvailable = credit.credits;
        this.currentCreditApi = credit.api;
        this.currentCreditReserved = credit.reservado;
        this.currentCreditReservedApi = credit.reservedApi;
        this.$refs.modal.show();
      },
      formatPriority (value) {
        const priority = this.priorities.find(priority => priority.value === value);
        return priority.label;
      },
      async onPriorityClick (item, index, target) {
        const info = item;
        Object.assign(this.userInfo, info);
        if (this.credit === 'Timeout') {
          this.isLoading = false;
          this.$toast.open({ message: 'Timeout de conexão!', type: 'error' });
          return;
        }
        this.accountLogin = item.login;
        this.priority = info.queuePriority;
        this.$refs.priorityModal.show();
      },
      resetModal () {
        this.bonus = '';
        this.bonusState = null;
        this.currentUser = {};
        this.currentCredit = 0;
      },
      handleModalOk (bvModalEvt) {
        bvModalEvt.preventDefault();
        this.handleSubmit();
      },
      async handleSubmit (e) {
        this.bonusState = this.bonus !== '';
        if (!this.bonusState) {
          return;
        }
        this.isLoading = true;
        await userService.bonusRegister({ accountId: this.currentUser.accountId, creditType: 'BN', amountOfTime: this.bonus * 60, api: this.api, recurrence: this.recurrence });
        this.isLoading = false;
        this.$toast.open('Bônus inserido (aii!!) com sucesso!');

        this.$nextTick(() => {
          this.$refs.modal.hide();
        });
      },

      handlePriorityModalOk (bvModalEvt) {
        bvModalEvt.preventDefault();
        this.handlePrioritySubmit();
      },
      async handlePrioritySubmit (e) {
        this.priorityState = this.priority !== '';
        if (!this.priorityState) {
          return;
        }

        this.isLoading = true;
        this.userInfo.queuePriority = this.priority;
        await userService.updateQueuePriority({ queuePriority: this.userInfo.queuePriority, login: this.accountLogin });
        this.isLoading = false;
        this.$toast.open('Prioridade alterada!');

        await this.loadUserAdminInfo({ perPage: parseInt(this.perPage), currentPage: this.currentPage, user: this.filterUserBonusText.trim().toLowerCase() });

        this.$nextTick(() => {
          this.$refs.priorityModal.hide();
        });
      },
      async onPurgeClick (item, index, target) {
        const info = item;
        Object.assign(this.userInfo, info);
        if (this.credit === 'Timeout') {
          this.isLoading = false;
          this.$toast.open({ message: 'Timeout de conexão!', type: 'error' });
          return;
        }
        this.purgeUpdateValue = info.purge / 24 / 60 / 60 / 1000;
        this.accountLogin = item.login;
        this.purge = info.purge;
        this.$refs.purgeModal.show();
      },
      resetPurgeModal () {
        this.purgeUpdateValue = 0;
      },
      handlePurgeModalOk (bvModalEvt) {
        bvModalEvt.preventDefault();
        this.handlePurgeSubmit();
      },
      async handlePurgeSubmit (e) {
        if (this.purgeUpdateValue === 0) {
          return;
        }

        this.isLoading = true;
        this.userInfo.purge = Number(this.purgeUpdateValue);

        await userService.updatePurge({ purge: this.userInfo.purge, login: this.accountLogin });

        this.isLoading = false;
        this.$toast.open('Data do expurgo alterada!');

        await this.loadUserAdminInfo({ perPage: parseInt(this.perPage), currentPage: this.currentPage, user: this.filterUserBonusText.trim().toLowerCase() });

        this.$nextTick(() => {
          this.$refs.purgeModal.hide();
        });
      }
    }
  };
</script>
